import {GetResourceParams, LoadNextPodEventsParams, LoadPodEventsParams, LoadPodEventsData} from "../shared/eventer-pod.ts";
import {ApiResponseResult} from "../../appfw/api-client/ApiClient.ts";
import {ResourceWrapper} from "./ResourceWrapper.ts";
import {EventerPodWorker} from "./eventer-pod-client.ts";

export class LocalEventerPod {

    readonly name: string
    readonly eventerPodWorker: EventerPodWorker;

    constructor(name: string) {
        this.name = name;
        this.eventerPodWorker = new EventerPodWorker()
    }

    async loadPodEvents(params: LoadPodEventsParams): Promise<ApiResponseResult<LoadPodEventsData<ResourceWrapper>>> {
        const result = await this.eventerPodWorker.call('loadPodEvents', params)
        return {
            data: result.data ? {
                events: result.data.events.map(r => new ResourceWrapper(r)),
                nextUrl: result.data.nextUrl,
            } : null,
            response: result.response,
        }
    }

    async loadNextPodEvents(params: LoadNextPodEventsParams): Promise<ApiResponseResult<LoadPodEventsData<ResourceWrapper>>> {
        const result = await this.eventerPodWorker.call('loadNextPodEvents', params)
        return {
            data: result.data ? {
                events: result.data.events.map(r => new ResourceWrapper(r)),
                nextUrl: result.data.nextUrl,
            } : null,
            response: result.response,
        }
    }

    async getResource(uri: GetResourceParams): Promise<ResourceWrapper | null> {
        const serializedResource = await this.eventerPodWorker.call('getResource', uri);
        if (serializedResource == null) {
            return null;
        }
        return new ResourceWrapper(serializedResource);
    }
}

const cache = new Map<string, Promise<LocalEventerPod>>()

export async function loadLocalEventerPod(name: string): Promise<LocalEventerPod> {
    let promise = cache.get(name)
    if (promise === undefined) {
        const localEventerPod = new LocalEventerPod(name)
        promise = localEventerPod.eventerPodWorker
            .call('init', undefined)
            .then(() => localEventerPod)
        cache.set(name, promise)
    }
    return await promise
}